import RequestError from '../components/RequestError';
import SectionErrorBoundary from '../components/SectionErrorBoundary';
import { requestErrorMessage } from '../../utils/requestErrorMessage';
import React, { Suspense, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import PageStartLoader from '../loaders/PageStartLoader'
import { useDispatch, useSelector } from 'react-redux';
import {
  localStorageHelper
} from '../../utils/localStorage';
import history from '../../utils/browserHistory'
import { handleError } from '../../utils/handleError'
import axios from 'axios'
import config from '../../config'
import mountingDelay from '../../utils/mountingDelay'
import { setInitialData } from '../../store/actionCreator'
import SideBar from '../sideBar/SideBar'
import routes from './routes'
import { WorkspaceThemeContext } from '../components/workspaceTheme/WorkspaceTheme'
import './talentDark.scss'
import MessageNotification from '../components/messageNotiffication/MessageNotification'

const API_URL = config.API_URL
const isHrsComsEnabled = value => value === true || value === 1 || value === '1' || value === 'true';

const TalentLayout = (props) => {
  const dispatch = useDispatch()
  const location = useLocation();
  const [loadError, setLoadError] = useState('');
  const [revision, setRevision] = useState(0);
  const { user } = useSelector(state => state);
  const userType = 'talent';
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => localStorageHelper.getItem('sidebarCollapsed') === 'true');

  const toggleSidebar = () => {
    setIsSidebarCollapsed(prev => {
      const next = !prev;
      localStorageHelper.setItem('sidebarCollapsed', String(next));
      return next;
    });
  };

  useEffect(() => {
    const controller = new AbortController();
    setLoadError('');
    const fetchData = async () => {
      const currentPath = window.location.pathname;
      if (currentPath === '/talent/feedback' && new URLSearchParams(window.location.search).has('token')) {
        return;
      }
      try {
        const userInfo = await axios.get(`${API_URL}/getUser`, { signal: controller.signal, timeout: 15000 });
        if (userInfo.data?.user?.type === 'talent' || userInfo.data?.type === 'talent') {
          dispatch(setInitialData({ ...userInfo.data }));
        } else if (userInfo.data?.user?.type === 'admin') {
          history.push('/dashboard');
        } else {
          history.push('/login');
        }
      } catch (error) {
        if (controller.signal.aborted) return;
        setLoadError(requestErrorMessage(error, 'Could not load your account. Please retry.'));
        if (error.response?.status === 401) {
          history.push('/login');
          return;
        }
        handleError(error, dispatch, history);
        console.error(error);
      }
    };
    const id = mountingDelay(fetchData)
    return () => {
      clearTimeout(id);
      controller.abort();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revision])

  const hasLoadedUser = Boolean(user?.id || user?.talentId || user?.email);

  return (
    <WorkspaceThemeContext.Provider value={true}>
    <div className="workspace-shell talent-layout min-h-screen flex overflow-x-hidden">
        <SideBar userType={userType} collapsed={isSidebarCollapsed} onToggleCollapse={toggleSidebar} />
      <section className={`workspace-theme workspace-content w-full min-w-0 bg-[#f5f8fd] transition-all duration-200 ${isSidebarCollapsed ? 'sm:ml-[64px] sm:w-[calc(100vw_-_64px)]' : 'sm:ml-[180px] sm:w-[calc(100vw_-_180px)]'} p-4 pb-24 sm:p-8 sm:pb-8 overflow-x-hidden`}>
        <RequestError message={loadError} onRetry={() => setRevision(value => value + 1)} />
        <SectionErrorBoundary key={location.pathname}>
        <Suspense fallback={<PageStartLoader />}>
          <Routes>
            {routes
              .filter(route => route.path !== '/my-finance' || !hasLoadedUser || user?.financeAccessEnabled !== false)
              .filter(route => route.path !== '/monthly-invoices' || !hasLoadedUser || user?.financeAccessEnabled !== false)
              .filter(route => route.path !== '/hours-reporting' || !hasLoadedUser || isHrsComsEnabled(user?.hrsComs))
              .map(route => {
              const { name, path, Component } = route
              return Component ? (
                <Route
                  exact={true}
                  key={name}
                  name={name}
                  path={path}
                  element={
                    <Component {...props} API_URL={API_URL} axios={axios} />
                  }
                />
              ) : null;
            })}
            <Route path="/*" element={<Navigate replace to="/talent/profile" />} />
          </Routes>
        </Suspense>
        </SectionErrorBoundary>
      </section>
        <MessageNotification />
    </div></WorkspaceThemeContext.Provider>
  )
}

export default TalentLayout
